import { toast } from "@win-reality/react-ui";

/**
 * Helper function to handle mutation or query errors.
 *
 * @param baseMessage A base message string describing the operation.
 * @param error The error object received.
 */
export function handleErrorNotification(
  baseMessage: string,
  error: Error | { detail?: string; message?: string },
): void {
  const errorDetail = getErrorDetail(error);
  toast(errorDetail ? `${baseMessage}: ${errorDetail}` : baseMessage, {
    variant: "error",
  });
}

/**
 * Helper function to get the detail from an error object.
 *
 * @param error The error object received.
 * @returns The detail from the error object.
 */
const getErrorDetail = (
  error: Error | { detail?: string; message?: string },
): string | undefined => {
  let detail: string | undefined;

  // First, check if the error object already has a 'detail' property.
  if ("detail" in error && error.detail) {
    detail = error.detail;
  }
  // Otherwise, sometimes the error message is a JSON string that holds the detail.
  else if (error?.message) {
    try {
      const parsed = JSON.parse(error.message);
      if (parsed?.detail) {
        detail = parsed.detail;
      }
    } catch (parseError) {
      // If parsing fails, fall back to using the error message directly.
      detail = error.message;
    }
  }

  return detail;
};
